module.exports = __webpack_public_path__ + "img/4-4.0acf97d2.svg";